import queryString from 'query-string';
import { VIDEO_TYPES } from './metadata';
import { getSeasons } from './ajax';
import { ALL_SEASONS } from './constants';

const DEFAULT_PAGE_SIZE = 50;
export function seasonSettingsToQueryString(showId, settings = {}) {
    const { selectedSeasons, videoType, includePassportVideos, selectedRegions } = settings;

    let params = {
        'show-id': showId,
        'page-size': DEFAULT_PAGE_SIZE
    };

    if (selectedRegions) {
        params['country'] = selectedRegions.map(({ value }) => value).join(',');
    }

    if ([VIDEO_TYPES.CLIP, VIDEO_TYPES.PREVIEW].includes(videoType)) {
        params['type'] = videoType;
    }
    if (videoType === VIDEO_TYPES.EPISODE) {
        params['parent-type'] = 'episode';
        params['type'] = VIDEO_TYPES.EPISODE;
    }
    if (selectedSeasons) {
        const seasonIds = selectedSeasons.map((season) => season.value).filter((value) => value);
        if (seasonIds.length) {
            params['seasonId'] = seasonIds;
        }
    }

    if (includePassportVideos) {
        params.available = 'station_members';
    } else {
        params.available = 'public';
    }
    const encodedParams = queryString.stringify(params);

    return `?${encodedParams}`;
}

/**
 * Memoized season fetcher. Returns parsed seasons array [ALL_SEASONS, ...seasons].
 * Deduplicates identical concurrent requests so multiple components calling with
 * the same params share a single API call.
 */
const _pendingRequests = {};

export function fetchShowSeasons(API, siteId, showId, settings) {
    const cacheKey = `${siteId}-${showId}-${seasonSettingsToQueryString(showId, settings)}`;

    if (_pendingRequests[cacheKey]) {
        return _pendingRequests[cacheKey];
    }

    const promise = getSeasons(API, siteId, showId, settings).then((response) => {
        return [
            ALL_SEASONS,
            ...response.map((item) => ({
                label: item.ordinal ? item.ordinal.toString() : null,
                value: item.id
            }))
        ];
    });

    _pendingRequests[cacheKey] = promise;

    // Clear cache once settled so future calls with same params make fresh requests
    promise.always(() => {
        delete _pendingRequests[cacheKey];
    });

    return promise;
}
